import ReactGA from "react-ga";
import { firebaseAuth } from "../firebase";
import * as authActions from "./actions";

export { authActions };
export * from "./action-types";
export { authReducer } from "./reducer";
export { getAuth, isAuthenticated } from "./selectors";

import { userActions } from "../user";
import { premiumActions } from "../premium";

export function initAuth(dispatch) {
  return new Promise((resolve, reject) => {
    firebaseAuth.onAuthStateChanged(
      user => {
        dispatch(authActions.initAuth(user));
        if (user) {
          ReactGA.set({ userId: user.uid });
          dispatch(userActions.userSignedIn(user));
          dispatch(premiumActions.userSignedIn(user));
          resolve(user);
        }
        resolve();
      },
      error => reject(error)
    );
  });
}



/** WEBPACK FOOTER **
 ** ./src/core/auth/index.js
 **/